import styled from 'styled-components'
import { Text } from 'components'
import { size } from 'utils/responsive'

export const LeftPanel = styled.div`
  flex: 0 0 auto;
  margin-right: 80px;
  margin-top: 8px;
`

export const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 620px;
  width: 100%;
`

export const PanelWrapper = styled.div`
  display: flex;
  user-select: none;

  @media only screen and (max-width: ${`${size.medium}px`}) {
    flex-direction: column;

    ${LeftPanel} {
      padding-bottom: 30px;
      max-width: 300px;
    }
  }
`

export const ContentWrapper = styled.section`
  max-width: 700px;
  margin-bottom: 30px;
`

export const InlineNotificationContainer = styled.div`
  min-height: 40px;

  .inline-notification {
    width: auto;
    padding-right: 15px;
  }
`

export const NotificationWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 55px 74px 60px;
  text-align: center;
`

export const StyledNotificationText = styled(Text)`
  align-items: center;
  display: flex;
  height: 25px;
  line-height: 24px;
  margin: 8px 0;
`

export const StyledNotificationSubtext = styled(StyledNotificationText)`
  ${(p) => p.theme.font({ color: 'gray5', size: 14 })};
`

export const SettingsFooter = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  height: 55px;
  width: 100%;
  bottom: 0;
  background-color: white;
  border-top: 1px solid ${(p) => p.theme.colors.gray2};
  padding: 8px 37px;
`

export const FormRow = styled.div`
  display: flex;

  > div {
    width: 100%;
  }

  > div:first-child {
    margin-right: 16px;
  }
`

export const Container = styled.div`
  padding: 8px 24px 10px 36px;

  & button {
    padding-left: 20px;
    padding-right: 20px;
  }
`

export const StyledSettingsFooter = styled(SettingsFooter)`
  justify-content: ${(props: { align?: string }) => (props.align === 'right' ? `flex-end` : `flex-start`)};
  width: 75%;

  & > * {
    margin: auto 16px;
  }

  & button {
    padding-left: 20px;
    padding-right: 20px;
  }

  & button:last-child {
    margin-right: ${(props: { align?: string }) => (props.align === 'right' ? `100px` : `inherit`)};
  }

  @media only screen and (max-width: ${`${size.medium}px`}) {
    width: 65%;
  }
`

export const BreadcrumbsWrapper = styled.div`
  margin: 18px 36px 0;
`

export const FieldContainer = styled.div`
  max-width: 620px;
`

export const FormContainer = styled.div`
  max-width: 620px;

  & > * {
    margin-top: 16px;
  }
`

export const TopRightWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: right;
  height: 0;
  top: -30px;
  right: 30px;

  & > * {
    margin-left: auto;
  }
`

export const TypographyHead = styled(Text)`
  font-size: 22px;
  font-weight: bold;
`

export const FlexCenter = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
